import { GlSprintf } from '@gitlab/ui';
import { s__ } from '~/locale';
const timeSpent = s__('TimeTracking|%{spentStart}Spent: %{spentEnd}');
export default {
    name: 'TimeTrackingSpentOnlyPane',
    timeSpent,
    components: {
        GlSprintf
    },
    props: {
        timeSpentHumanReadable: {
            type: String,
            required: true
        }
    }
};
